// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1nRxY","item":"PaymentsMobile_item__UKvKt","label":"PaymentsMobile_label__3mZbC","amount":"PaymentsMobile_amount__OYJOi"};